import { forwardRef, HTMLProps } from 'react'
import clsx from 'clsx'

type InputProps = HTMLProps<HTMLInputElement>

const InputColor = forwardRef<HTMLInputElement, InputProps>(
  ({ className, label, id, ...rest }, ref) => (
    <div className="flex items-center mb-2">
      <label htmlFor={id} data-content={label} className="w-full text-sm">
        {label}
      </label>
      <div className="w-full">
        <input
          id={id}
          className={clsx(
            'rounded h-10 p-1 outline-none shadow disabled:opacity-50',
            className
          )}
          type="color"
          ref={ref}
          {...rest}
        />
      </div>
    </div>
  )
)

export default InputColor
